import { createFileRoute } from '@tanstack/react-router';
import { NotificationsPage } from '@/features/pwa/pages/notifications-page';

export const Route = createFileRoute('/_app/me/notifications')({ component: NotificationsPage });
